module.exports = __webpack_public_path__ + "static/media/monitor.15afaf30.svg";